import React, { useEffect } from 'react';
import TermsAndConditions from './TermsAndConditions';

const TracsessUserTerms: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <TermsAndConditions
      appName="Tracsess"
      pdfUrl="https://tracess.s3.ap-south-1.amazonaws.com/documents/tracsess-user/TOS_Tracsess.pdf"
      title="Tracsess - Terms and Conditions"
    />
  );
};

export default TracsessUserTerms; 